
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderPreLoginComponent } from '../header-pre-login/header-pre-login.component';
import { FooterComponent } from '../footer/footer.component';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { RouterModule } from '@angular/router';
import { CuttoffTimingModalComponent } from './cuttoff-timing-modal/cuttoff-timing-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CuttoffTimingModalBseComponent } from './cuttoff-timing-modal-bse/cuttoff-timing-modal-bse.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OtpComponent } from './otp/otp.component';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ClientProfileModelComponent } from './client-profile-model/client-profile-model.component';
import { AddNomineeComponent } from './add-nominee/add-nominee.component';
import { RiskprofileModelComponent } from './riskprofile-model/riskprofile-model.component';
import { DigitalKYCModelComponent } from './digital-kyc-model/digital-kyc-model.component';
import { ProfilePreviewModelComponent } from './profile-preview-model/profile-preview-model.component';
import { ClientsFilterComponent } from './clients-filter/clients-filter.component';
import { ExploreFundsFilterPipe } from '../filters/explore-funds-filter.pipe';
import { ExploreFundsNsePipe } from '../filters/explore-funds-nse.pipe';
import { HeaderJmComponent } from './header-jm/header-jm.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown-angular7';
import { FdTermsAndConditionComponent } from './fd-terms-and-condition/fd-terms-and-condition.component';
import { GetFilterDataComponent } from './get-filter-data/get-filter-data.component';
import { PanSearchComponent } from './pan-search/pan-search.component';
import { TwoFaotpComponent } from './two-faotp/two-faotp.component';
import { PaymentModePopupComponent } from './payment-mode-popup/payment-mode-popup.component';
import { TransactionOtpComponent } from './transaction-otp/transaction-otp.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { PoaEdisComponent } from './poa-edis/poa-edis.component';
import { SearchingPipe } from './searching.pipe';
import { NumbersToWordsPipe } from '../filters/numbers-to-words.pipe';
import { RiskProfileModalComponent } from '../risk-profile-new/risk-profile-modal/risk-profile-modal.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { NoAutofillDirective } from '../directive/no-autofill.directive';
@NgModule({
  declarations: [
    HeaderPreLoginComponent,
    FooterComponent,
    ContactUsComponent,
    ConfirmationDialogComponent,
    CuttoffTimingModalComponent,
    CuttoffTimingModalBseComponent,
    TermsAndConditionsComponent,
    OtpComponent,
    ClientProfileModelComponent,
    AddNomineeComponent,
    RiskprofileModelComponent,
    DigitalKYCModelComponent,
    ProfilePreviewModelComponent,
    ClientsFilterComponent,
    ExploreFundsFilterPipe,
    ExploreFundsNsePipe,
    HeaderJmComponent,
    FdTermsAndConditionComponent,
    GetFilterDataComponent,
    PanSearchComponent,
    TwoFaotpComponent,
    PaymentModePopupComponent,
    TransactionOtpComponent,
    PoaEdisComponent,
    SearchingPipe,
    NumbersToWordsPipe,
    RiskProfileModalComponent,
    AboutUsComponent,
    DisclaimerComponent,
    NoAutofillDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    NgOtpInputModule,
    ReactiveFormsModule,
    FormsModule,
    TooltipModule,
    ModalModule.forRoot(), // ModalModule comes from ngx-bootstrap
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: [ 
    SearchingPipe,
    HeaderPreLoginComponent,
    FooterComponent,
    ContactUsComponent,
    ConfirmationDialogComponent,
    CuttoffTimingModalComponent,
    CuttoffTimingModalBseComponent,
    TermsAndConditionsComponent,
    OtpComponent,
    ClientProfileModelComponent,
    AddNomineeComponent,
    RiskprofileModelComponent,
    DigitalKYCModelComponent,
    ProfilePreviewModelComponent,
    ClientsFilterComponent,
    ExploreFundsFilterPipe,
    ExploreFundsNsePipe,
    HeaderJmComponent,
    FdTermsAndConditionComponent,
    GetFilterDataComponent,
    PanSearchComponent,TransactionOtpComponent,
    NumbersToWordsPipe,
    RiskProfileModalComponent,
    AboutUsComponent,
    DisclaimerComponent,
    NoAutofillDirective
  ],
  entryComponents: [ConfirmationDialogComponent, OtpComponent, AddNomineeComponent, RiskprofileModelComponent, DigitalKYCModelComponent, ProfilePreviewModelComponent],
  providers: [OtpComponent, ConfirmationDialogComponent, AddNomineeComponent, RiskprofileModelComponent, DigitalKYCModelComponent, ProfilePreviewModelComponent,RiskProfileModalComponent]
})
export class SharedModule { }
